module.exports = __webpack_public_path__ + "static/media/dairy-section.2a49c625.png";